<nb-select placeholder="Gebäudeteil auswählen"
           [(selected)]="value"
           [disabled]="isDisabled"
           fullWidth>
  @for (buildingSection of buildingSections(); track buildingSection.id) {
    <nb-option
               [value]="buildingSection.id">
      {{ buildingSection.address.street}} {{ buildingSection.address.number}}
    </nb-option>
  }
</nb-select>
